import DeclinedServicesPage from './DeclinedServicesPage';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

// Actions
import { goTo } from 'store/reducers/navigation/actions';
import {
  clearDeclinedServices,
  addDeclinedService
} from 'store/reducers/appointment/actions';
import { gtmUserEvent } from 'store/reducers/gtm/actions';

// Selectors
import { getDeclinedServicesPromotion as getDeclinedServices } from 'store/reducers/declined/selectors';
import { getDeferredServices } from 'store/reducers/deferred/selectors';
import {
  getDeclinedServices as getApptDeclinedServices,
  getSelectedDeferredServicesIds,
  vehicleEditableEnabled,
  getVehicle
} from 'store/reducers/appointment/selectors';
import {
  getActivePromotion,
  getPromotionGroupByType
} from 'store/reducers/promotions/selectors';
import { getShowMileage } from 'store/reducers/dealerSettings/selectors';
import { isLoggedIn } from 'store/reducers/user/selectors';
import {
  getCTABanner,
  showProgressBar,
  hideBottomCTA,
  getBackButton
} from 'store/reducers/optimizelyABTest/selectors';

// Utils
import { undefinedToTrue } from 'utils/varValidation';

const mapStateToProps = state => {
  return {
    declinedServices: getDeclinedServices(state),
    deferredServices: getDeferredServices(state),
    apptDeclinedServices: getApptDeclinedServices(state),
    apptDeferredServices: getSelectedDeferredServicesIds(state),
    promotionGroup: getPromotionGroupByType(state),
    promotion: getActivePromotion(state),
    showMileage: undefinedToTrue(getShowMileage(state)),
    vehicleEditableEnabled: vehicleEditableEnabled(state),
    isLoggedIn: isLoggedIn(state),
    vehicle: getVehicle(state),
    ctaBanner: getCTABanner(state),
    showProgressBar: showProgressBar(state),
    hideBottomCTA: hideBottomCTA(state),
    ctaBackButton: getBackButton(state)
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      clearDeclinedServices,
      addDeclinedService,
      gtmUserEvent,
      goTo
    },
    dispatch
  );
export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(DeclinedServicesPage);



// WEBPACK FOOTER //
// ./src/components/pages/DeclinedServicesPage/DeclinedServicesPageContainer.js